/* CycloOutlet analytics baseline v90 — attribution + custom storefront signals.
   Standard ecommerce events (view_item/add_to_cart/remove_from_cart/begin_checkout/purchase)
   should be sourced from Shopify Customer Events / Web Pixels to avoid click-only false positives. */
(() => {
  'use strict';
  const VERSION = 'v90';
  const ATTR_KEY = 'co_attribution_v1';
  const VIEW_KEY = 'co_viewed_products_v1';
  const MAX_VIEWS = 20;
  const body = document.body;

  const clean = (value, max = 140) => String(value || '').replace(/\s+/g, ' ').trim().slice(0, max);
  const now = () => new Date().toISOString();
  const readJSON = (key, fallback) => {
    try { return JSON.parse(localStorage.getItem(key) || '') || fallback; } catch (_) { return fallback; }
  };
  const writeJSON = (key, value) => { try { localStorage.setItem(key, JSON.stringify(value)); } catch (_) {} };

  const params = new URLSearchParams(location.search);
  const incoming = {
    utm_source: clean(params.get('utm_source'), 80),
    utm_medium: clean(params.get('utm_medium'), 80),
    utm_campaign: clean(params.get('utm_campaign'), 120),
    utm_content: clean(params.get('utm_content'), 120),
    utm_term: clean(params.get('utm_term'), 120),
    gclid: clean(params.get('gclid'), 120),
    fbclid: clean(params.get('fbclid'), 120),
    ttclid: clean(params.get('ttclid'), 120),
    landing_page: clean(location.pathname + location.search, 240),
    referrer: clean(document.referrer, 240),
    captured_at: now()
  };
  const hasCampaign = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','fbclid','ttclid'].some(k => incoming[k]);
  const existing = readJSON(ATTR_KEY, {});
  let attribution = existing;
  if (!existing.first_touch) {
    attribution = { ...existing, first_touch: incoming, last_touch: incoming };
    writeJSON(ATTR_KEY, attribution);
  } else if (hasCampaign) {
    attribution = { ...existing, last_touch: incoming };
    writeJSON(ATTR_KEY, attribution);
  }

  const attributionPayload = () => {
    const a = readJSON(ATTR_KEY, attribution || {});
    const first = a.first_touch || {};
    const last = a.last_touch || first;
    return {
      first_utm_source: first.utm_source || '',
      first_utm_medium: first.utm_medium || '',
      first_utm_campaign: first.utm_campaign || '',
      last_utm_source: last.utm_source || '',
      last_utm_medium: last.utm_medium || '',
      last_utm_campaign: last.utm_campaign || '',
      last_utm_content: last.utm_content || '',
      landing_page: first.landing_page || location.pathname
    };
  };

  const publish = (eventName, data = {}) => {
    const payload = { measurement_version: VERSION, ...attributionPayload(), ...data };
    if (window.CycloOutletMetrics?.track) window.CycloOutletMetrics.track(eventName, payload);
    else if (typeof window.gtag === 'function') window.gtag('event', eventName, payload);
    try { window.Shopify?.analytics?.publish?.(eventName, payload); } catch (_) {}
  };

  window.CycloOutletAttribution = { get: attributionPayload };

  // Keep a short, local sequence of viewed products. Useful later for checkout/purchase pathing.
  if ((body?.dataset?.pageType || '').toLowerCase() === 'product') {
    const handle = clean(body.dataset.productHandle, 100);
    const title = clean(body.dataset.productTitle || document.querySelector('h1')?.textContent, 140);
    if (handle || title) {
      const history = readJSON(VIEW_KEY, []);
      const next = history.filter(x => x && x.handle !== handle);
      next.push({ handle, title, ts: now() });
      writeJSON(VIEW_KEY, next.slice(-MAX_VIEWS));
    }
  }

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const finance = target.closest('[data-co-financing-click]');
    if (finance) {
      publish('co_financing_click', {
        provider: clean(finance.dataset.financingProvider, 40),
        product_handle: clean(body?.dataset?.productHandle, 100),
        product_title: clean(body?.dataset?.productTitle, 140),
        page_path: location.pathname
      });
    }

    const landingCta = target.closest('[data-co-landing-cta]');
    if (landingCta) {
      publish('co_landing_cta_click', {
        landing_id: clean(landingCta.dataset.landingId, 80),
        cta_type: clean(landingCta.dataset.ctaType, 60),
        destination: clean(landingCta.getAttribute('href'), 180)
      });
    }
  });

  document.addEventListener('change', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    if (target.matches('[data-option-index]')) {
      const section = target.closest('[data-apex-product-detail]');
      publish('co_variant_select', {
        product_handle: clean(body?.dataset?.productHandle, 100),
        product_title: clean(body?.dataset?.productTitle, 140),
        option_index: clean(target.getAttribute('data-option-index'), 8),
        option_value: clean(target.value, 80),
        variant_id: clean(section?.querySelector('[data-variant-select]')?.value, 50)
      });
    }
  });
})();
